import React, { useState, useEffect } from "react";
import { Buffer } from "buffer";
import { API, Auth, graphqlOperation } from "aws-amplify";
import * as queries from "../../../graphql/queries";
import {
  browserName,
  browserVersion,
  osName,
  osVersion,
  deviceType,
  deviceDetect,
  mobileModel,
  mobileVendor,
  isMobile,
} from "react-device-detect";
import {
  updateUserProfileDetails,
  createServicesLogs,
  updateCardItems,
  createCard,
  createCardItems,
  createFriendRequest,
  updateInviteConnections,
  createUserActivity,
  deleteUserActivity,
  createPostViews,
  deleteInterestUser,
  deleteSubinterestUser,
} from "../../../graphql/mutations";
import {
  welcomeemail,
  sendemailnsms,
  otpMobileSendDev,
  sendparentalconsent,
  otpvarify,
  getparentalconsent,
  env,
  appLink,
  selfemailverification,
  mbileverificationreminder,
  userinvitation,
  notification,
  connectionrequestsent,
  connectionrequestaccept,
} from "./CustomConstants";
import axios from "axios";
import fetchItemsNextToken from "../../../graphql/fetchItemsNextToken";
import moment from "moment";
import {
  ContentState,
  convertToRaw,
  EditorState,
  convertFromHTML,
} from "draft-js";
import fetchSearchItemsNextToken from "../../../graphql/fetchSearchItemsNextToken";
import { moodleApiUrl, moodleToken, s3CloudFrontUrl, cloudfrontKeyPairId } from "./CustomConstants";

export async function addEventLog(
  action_done_by_user_id,
  entity_owner_user_id,
  entity_id,
  payload_before,
  payload_after,
  intersets
) {
  let userLogin = "";
  let isThirdPartyLinkEvent = false;
  let thirdPartyLink = "";
  if (entity_id == "3cdfcab3-945a-47c9-9e01-471ad3bbb989") {
    let socialLogin = localStorage.getItem("socialLogin");
    if (socialLogin) {
      userLogin = socialLogin;
    } else {
      userLogin = "By Email";
    }
  }

  if(entity_id == "53d50a5d-9626-4e02-aaf0-cb766207881b") {
    isThirdPartyLinkEvent = true;
    thirdPartyLink = payload_after.thirdPartyLink;
  }

  if (payload_before == "") {
    payload_before = JSON.stringify(JSON.stringify({}));
  } else {
    payload_before = JSON.stringify(JSON.stringify(payload_before));
  }

  if (payload_after == "") {
    payload_after = JSON.stringify(JSON.stringify({}));
  } else {
    payload_after = JSON.stringify(JSON.stringify(payload_after));
  }
  if (intersets != "") {
    intersets = intersets;
  } else {
    intersets = "";
  }
  var referrer = isThirdPartyLinkEvent === true && thirdPartyLink !== "" ? thirdPartyLink : document.referrer;
  
  API.post("welcomeemaildev", "/eventLog", {
    body: { data: {
      action_done_by_user_id: action_done_by_user_id,
      entity_id: entity_id,
      entity_owner_user_id: entity_owner_user_id,
      payload_after: payload_after,
      payload_before: payload_before,
      interests: intersets,
      referrer: referrer,
      registrationType: userLogin,
      userBrowser: browserName + " - " + browserVersion,
      userOS: osName + " - " + osVersion,
      userDevice: isMobile == true ? deviceType + " - " + mobileModel + " - " + mobileVendor : deviceType,
      createdAt: new Date(Date.now()).toISOString(),
    } },
  });

}

export async function getUseraccess(userid) {
  //console.log("userid",userid);
  // LOGIN USER ACCESS
  if (userid.length > 0) {
    //const userData = await API.graphql(graphqlOperation(queries.listUserMasters,{filter: {id: {eq: userid}},limit:10000}));
    //  const userData=await fetchItemsNextToken({query:queries.listUserMasters,variables:{filter: {id: {eq: userid}},limit:10000}})
    let userData = await fetchSearchItemsNextToken({
      query: queries.searchUserMasters,
      variables: { filter: { id: { eq: userid } }, limit: 500 },
    });
    const items = userData;
    let newData = items.filter((item) => item._deleted !== true);
    //console.log('newData',newData);

    //const userDetailsData = await API.graphql(graphqlOperation(queries.listUserProfileDetails,{filter: {userProfileDetailsUserMasterId: {eq: newData[0].id}},limit:10000}));
    // let userDetailsData=await fetchItemsNextToken({query:queries.listUserProfileDetails,variables:{filter: {userProfileDetailsUserMasterId: {eq: newData[0].id}},limit:500}})
    let userDetailsData = await fetchSearchItemsNextToken({
      query: queries.searchUserProfileDetails,
      variables: {
        filter: { userProfileDetailsUserMasterId: { eq: newData[0].id } },
        limit: 500,
      },
    });

    const itemDetails = userDetailsData;
    let newDetailData = itemDetails.filter((item) => item._deleted !== true);
    // SET VERIABLE FOR ACCESS ROLE
    var isMobileVerified =
      newDetailData[0].isMobileVerified == null ||
      newDetailData[0].isMobileVerified == false
        ? 0
        : 1;
    var isParentVerified =
      newDetailData[0].isParentVerified == null ||
      newDetailData[0].isParentVerified == false
        ? 0
        : 1;
    var isSelfEmailVerified =
      newDetailData[0].isSelfEmailVerified == null ||
      newDetailData[0].isSelfEmailVerified == false
        ? 0
        : 1;
    // var isDisabled=(newDetailData[0].status==null || newDetailData[0].status!=9)?0:1;
    var isDisabled = newDetailData[0].userID?.disabled == 1 ? 1 : 0;
    var isMinor = newData[0].isParent == true ? 1 : 0;

    //BUG - the user access table is returning NO entry when isMobileVerified: 0, isSelfEmailVerified: 1, isMinor: 0, isParentVerified: 0, isDisabled: 1
    //to overcome this bug setting isMobileVerified to 1, since we anyways dont want user to login if isDisabled is 1
    if (isDisabled === 1 && isMobileVerified === 0) {
      isMobileVerified = 1;
    }

    // console.log("isMobileVerified==>",isMobileVerified);
    // console.log("isParentVerified==>",isParentVerified);
    // console.log("isSelfEmailVerified==>",isSelfEmailVerified);
    // console.log("isDisabled==>",isDisabled);
    // console.log("isMinor==>",isMinor);

    //const userAccessData = await API.graphql(graphqlOperation(queries.listUserAccessRoles,{limit:10000}));
    const userAccessData = await fetchItemsNextToken({
      query: queries.listUserAccessRoles,
      variables: { limit: 10000 },
    });
    // console.log('userAccessData==>',userAccessData);
    const roleitems = userAccessData.filter((item) => item.priority == 1);
    //console.log('roleitems',roleitems);

    // convert regulaer expression match in future and check wild rule also
    let rolenewData = roleitems.find(
      (item) =>
        item.isMobileVerified == isMobileVerified &&
        item.isParentVerified == isParentVerified &&
        item.isSelfEmailVerified == isSelfEmailVerified &&
        item.isDisabled == isDisabled &&
        item.isMinor == isMinor
    );
    //console.log('rolenewData',rolenewData);

    // if(rolenewData==undefined || rolenewData=="")
    // {
    // var options = {
    //   'isMobileVerified':isMobileVerified,
    //   'isParentVerified':isParentVerified,
    //   'isSelfEmailVerified':isSelfEmailVerified,
    //   'isDisabled':isDisabled,
    //   'isMinor':isMinor
    // };

    // const userDetailsData1 = { 'module':"USER ACCESS ROLE",'createdAt':new Date(Date.now()).toISOString(),'request':JSON.stringify(options),'response':'','status':1,'type':'USER ACCESS ROLE'};
    // console.log("userDetailsData===>",userDetailsData);

    // let userAdd=await API.graphql(graphqlOperation(createServicesLogs, { input: userDetailsData1 }));
    //  }
    return rolenewData;
  } // GUEST USER ACCESS
  else {
    //,limit:10000
    //const userAccessData = await API.graphql(graphqlOperation(queries.listUserAccessRoles,{limit:10000}));
    const userAccessData = await fetchItemsNextToken({
      query: queries.listUserAccessRoles,
      variables: { limit: 10000 },
    });
    const roleitems = userAccessData.filter((item) => item.priority == 1);
    let rolenewData = roleitems.find(
      (item) =>
        item.isMobileVerified == 0 &&
        item.isParentVerified == 0 &&
        item.isSelfEmailVerified == 0 &&
        item.isDisabled == 0 &&
        item.isMinor == 0
    );

    // if(rolenewData==undefined || rolenewData=="")
    // {
    // var options = {
    //   'isMobileVerified':isMobileVerified,
    //   'isParentVerified':isParentVerified,
    //   'isSelfEmailVerified':isSelfEmailVerified,
    //   'isDisabled':isDisabled,
    //   'isMinor':isMinor
    // };

    // const userDetailsData1 = { 'module':"USER ACCESS ROLE",'createdAt':new Date(Date.now()).toISOString(),'request':JSON.stringify(options),'response':'','status':1,'type':'USER ACCESS ROLE'};
    // console.log("userDetailsData===>",userDetailsData);

    // let userAdd=await API.graphql(graphqlOperation(createServicesLogs, { input: userDetailsData1 }));
    //  }
    return rolenewData;
  }
}

export async function getUserAccessForUsername(username) {
  if (username !== null || username !== undefined) {
    let userData = await fetchSearchItemsNextToken({
      query: queries.searchUserMasters,
      variables: { filter: { username: { eq: username } }, limit: 500 },
    });
    const items = userData;
    let newData = items.filter((item) => item._deleted !== true);

    let userDetailsData = await fetchSearchItemsNextToken({
      query: queries.searchUserProfileDetails,
      variables: {
        filter: { userProfileDetailsUserMasterId: { eq: newData[0].id } },
        limit: 500,
      },
    });

    const itemDetails = userDetailsData;
    let newDetailData = itemDetails.filter((item) => item._deleted !== true);
    // SET VERIABLE FOR ACCESS ROLE
    var isMobileVerified =
      newDetailData[0].isMobileVerified == null ||
      newDetailData[0].isMobileVerified == false
        ? 0
        : 1;
    var isParentVerified =
      newDetailData[0].isParentVerified == null ||
      newDetailData[0].isParentVerified == false
        ? 0
        : 1;
    var isSelfEmailVerified =
      newDetailData[0].isSelfEmailVerified == null ||
      newDetailData[0].isSelfEmailVerified == false
        ? 0
        : 1;
    // var isDisabled=(newDetailData[0].status==null || newDetailData[0].status!=9)?0:1;
    var isDisabled = newDetailData[0].userID?.disabled == 1 ? 1 : 0;
    var isMinor = newData[0].isParent == true ? 1 : 0;

    //BUG - the user access table is returning NO entry when isMobileVerified: 0, isSelfEmailVerified: 1, isMinor: 0, isParentVerified: 0, isDisabled: 1
    //to overcome this bug setting isMobileVerified to 1, since we anyways dont want user to login if isDisabled is 1
    if (isDisabled === 1 && isMobileVerified === 0) {
      isMobileVerified = 1;
    }

    //const userAccessData = await API.graphql(graphqlOperation(queries.listUserAccessRoles,{limit:10000}));
    const userAccessData = await fetchItemsNextToken({
      query: queries.listUserAccessRoles,
      variables: { limit: 10000 },
    });
    // console.log('userAccessData==>',userAccessData);
    const roleitems = userAccessData.filter((item) => item.priority == 1);
    //console.log('roleitems',roleitems);

    // convert regulaer expression match in future and check wild rule also
    let rolenewData = roleitems.find(
      (item) =>
        item.isMobileVerified == isMobileVerified &&
        item.isParentVerified == isParentVerified &&
        item.isSelfEmailVerified == isSelfEmailVerified &&
        item.isDisabled == isDisabled &&
        item.isMinor == isMinor
    );
    return rolenewData;
  }
}

export async function sendparentalconsentEmail(userId) {
  //const userDetailsData = await API.graphql(graphqlOperation(queries.listUserProfileDetails,{filter: {userProfileDetailsUserMasterId: {eq: userId}},limit:10000}));
  const userDetailsData = await fetchItemsNextToken({
    query: queries.listUserProfileDetails,
    variables: {
      filter: { userProfileDetailsUserMasterId: { eq: userId } },
      limit: 500,
    },
  });

  const itemDetails = userDetailsData;
  let newDetailData = itemDetails.filter((item) => item._deleted !== true);
  let parentEmailEncode = Buffer.from(
    newDetailData[0].parent_email.toLowerCase()
  ).toString("base64");
  const apiName = "welcomeemaildev";
  const path = "/sendParentalConsent";
  const myInit = {
    body: {
      email_parent: newDetailData[0].parent_email,
      parent_name: newDetailData[0].parent_name,
      student_name: newDetailData[0].first_name,
      link:
        window.location.origin +
        "/success-parental/" +
        userId +
        "/" +
        parentEmailEncode,
    },
  };

  await API.post(apiName, path, myInit)
    .then(async (result) => {
      let cnt = newDetailData[0].parentRequestSentTriggerCnt + 1;
      const userDetailsData = {
        id: newDetailData[0].id,
        parentRequestSentTriggerCnt: cnt,
        parentRequestSentTriggerDt: new Date(Date.now()).toISOString(),
      };

      let userAdd = await API.graphql(
        graphqlOperation(updateUserProfileDetails, { input: userDetailsData })
      );
      return true;
    })
    .catch((error) => {
      console.log(error.response);
      return false;
    });

  // var myHeaders = new Headers();
  // myHeaders.append("Content-Type", "application/json");
  // let parentEmailEncode = Buffer.from((newDetailData[0].parent_email).toLowerCase()).toString('base64')
  // var raw = JSON.stringify({
  //   "email_parent":newDetailData[0].parent_email,
  //   "parent_name": newDetailData[0].parent_name,
  //   "student_name" : newDetailData[0].first_name,
  //   "link": window.location.origin+'/success-parental/'+userId+'/'+parentEmailEncode
  // });

  // var requestOptions = {
  //   method: 'POST',
  //   headers: myHeaders,
  //   body: raw,
  //   redirect: 'follow'
  // };

  // fetch(sendparentalconsent, requestOptions)
  //   .then(response =>{
  //     response.text();
  //     return true;
  //   } )
  //   .then(async result =>{
  //       console.log(result);
  //       let cnt=newDetailData[0].parentRequestSentTriggerCnt+1;
  //       const userDetailsData = { 'id':newDetailData[0].id,'parentRequestSentTriggerCnt':cnt,'parentRequestSentTriggerDt':new Date(Date.now()).toISOString(),'_version':newDetailData[0]._version};
  //       console.log("userDetailsData===>",userDetailsData);

  //       let userAdd=await API.graphql(graphqlOperation(updateUserProfileDetails, { input: userDetailsData }));
  //       return true;
  //   })
  //   .catch(error =>{
  //     console.log('error', error)
  //     return false;
  //   } );
}

export async function sendEmailOtp(data) {
  const apiName = "welcomeemaildev";
  const path = "/sendemailnsms";
  const myInit = {
    body: {
      email: data[0].email.toLowerCase(),
      mobile_no: data[0].mobile_no,
      register: data[0].register,
      social_login: data[0].social_login,
      resent: data[0].resent,
      country_code: data[0].countryCode,
    },
  };

  await API.post(apiName, path, myInit)
    .then((response) => {
      return true;
      //response.text()
    })
    .catch((error) => {
      console.log("error", error);
      return false;
    });
  // var myHeaders = new Headers();
  //  myHeaders.append("Content-Type", "application/json");

  //  var raw = JSON.stringify({
  //    "email": data[0].email.toLowerCase(),
  //    "mobile_no": data[0].mobile_no,
  //    "register" : data[0].register,
  //    "social_login" : data[0].social_login,
  //    "resent" : data[0].resent,
  //    "country_code":data[0].countryCode
  //  });

  //  var requestOptions = {
  //    method: 'POST',
  //    headers: myHeaders,
  //    body: raw,
  //    redirect: 'follow'
  //  };

  //  fetch(sendemailnsms, requestOptions)
  //    .then(response => {
  //      response.text()
  //      return true
  //    }
  //     )
  //    .then(async result => {

  //       return true;
  //    })
  //    .catch(error =>{
  //      return false
  //      console.log('error', error)
  //    } );
}

export async function sendSmsMobile(userId, mobile_no, mobileCountrycode) {
  //const userDetailsData = await API.graphql(graphqlOperation(queries.listUserProfileDetails,{filter: {userProfileDetailsUserMasterId: {eq: userId}},limit:10000}));
  const userDetailsData = await fetchItemsNextToken({
    query: queries.listUserProfileDetails,
    variables: {
      filter: { userProfileDetailsUserMasterId: { eq: userId } },
      limit: 500,
    },
  });

  const itemDetails = userDetailsData;
  let newDetailData = itemDetails.filter((item) => item._deleted !== true);

  const apiName = "welcomeemaildev";
  const path = "/sendemailnsms";
  const myInit = {
    body: {
      email: newDetailData[0].userID.email.toLowerCase(),
      mobile_no: mobile_no,
      register: true,
      social_login: false,
      resent: "mobile",
      country_code: mobileCountrycode,
    },
  };

  await API.post(apiName, path, myInit)
    .then(async (result) => {
      let cnt = newDetailData[0].mobileSmsTriggerCnt + 1;
      const userDetailsData = {
        id: newDetailData[0].id,
        mobileSmsTriggerCnt: cnt,
        mobileSmsTriggerDt: new Date(Date.now()).toISOString(),
      };

      let userAdd = await API.graphql(
        graphqlOperation(updateUserProfileDetails, { input: userDetailsData })
      );
      return true;
    })
    .catch((error) => {
      console.log("error", error);
      return false;
    });
  // var myHeaders = new Headers();
  // myHeaders.append("Content-Type", "application/json");

  // var raw = JSON.stringify({
  //   "email": newDetailData[0].userID.email.toLowerCase(),
  //   "mobile_no": mobile_no,
  //   "register" :true,
  //   "social_login" : false,
  //   "resent" : 'mobile',
  //   "country_code":mobileCountrycode
  // });

  // var requestOptions = {
  //   method: 'POST',
  //   headers: myHeaders,
  //   body: raw,
  //   redirect: 'follow'
  // };

  // fetch(sendemailnsms, requestOptions)
  //   .then(response => {
  //     response.text()
  //     return true
  //   }
  //    )
  //   .then(async result => {
  //     let cnt=newDetailData[0].mobileSmsTriggerCnt+1;
  //     const userDetailsData = { 'id':newDetailData[0].id,'mobileSmsTriggerCnt':cnt,'mobileSmsTriggerDt':new Date(Date.now()).toISOString(),'_version':newDetailData[0]._version};
  //     console.log("userDetailsData===>",userDetailsData);

  //     let userAdd=await API.graphql(graphqlOperation(updateUserProfileDetails, { input: userDetailsData }));
  //     return true;
  //   })
  //   .catch(error =>{
  //     return false
  //     console.log('error', error)
  //   } );
}

export async function sendWelcomeEmail(userId) {

  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  //const userDetailsData = await API.graphql(graphqlOperation(queries.listUserProfileDetails,{filter: {userProfileDetailsUserMasterId: {eq: userId}},limit:10000}));
  const userDetailsData = await fetchItemsNextToken({
    query: queries.listUserProfileDetails,
    variables: {
      filter: { userProfileDetailsUserMasterId: { eq: userId } },
      limit: 500,
    },
  });

  const itemDetails = userDetailsData;
  let newDetailData = itemDetails.filter((item) => item._deleted !== true);

  const apiName = "welcomeemaildev";
  const path = "/welcomeemaildev";
  const myInit = {
    body: {
      email: newDetailData[0].userID.email.toLowerCase(),
      name: newDetailData[0].first_name,
    },
  };

  await API.post(apiName, path, myInit)
    .then(async (response) => {
      let cnt = newDetailData[0].welcomeEmailSentCnt + 1;
      const userDetailsData = {
        id: newDetailData[0].id,
        welcomeEmailSentCnt: cnt,
        welcomeEmailSentDt: new Date(Date.now()).toISOString(),
        _version: newDetailData[0]._version,
      };

      let userAdd = await API.graphql(
        graphqlOperation(updateUserProfileDetails, { input: userDetailsData })
      );
      return true;
    })
    .catch((error) => {
      console.log(error.response);
      return false;
    });

  return true;
}

export async function sendSelfverificationemail(userId) {
  //const userDetailsData = await API.graphql(graphqlOperation(queries.listUserProfileDetails,{filter: {userProfileDetailsUserMasterId: {eq: userId}},limit:10000}));
  const userDetailsData = await fetchItemsNextToken({
    query: queries.listUserProfileDetails,
    variables: {
      filter: { userProfileDetailsUserMasterId: { eq: userId } },
      limit: 500,
    },
  });

  const itemDetails = userDetailsData;
  let newDetailData = itemDetails.filter((item) => item._deleted !== true);
  const encodenewuserID = Buffer.from(newDetailData[0].userID.email).toString(
    "base64"
  );
  const link = window.location.origin + "/email-activation/" + encodenewuserID;
  const apiName = "welcomeemaildev";
  const path = "/selfemailverification";
  const myInit = {
    body: {
      email: newDetailData[0].userID.email.toLowerCase(),
      name: newDetailData[0].first_name,
      link: link,
    },
  };

  await API.post(apiName, path, myInit)
    .then(async (response) => {
      let cnt = newDetailData[0].selfEmailTriggerCnt + 1;
      const userDetailsData = {
        id: newDetailData[0].id,
        selfEmailTriggerCnt: cnt,
        selfEmailTriggerDt: new Date(Date.now()).toISOString(),
      };

      let userAdd = await API.graphql(
        graphqlOperation(updateUserProfileDetails, { input: userDetailsData })
      );
      return true;
    })
    .catch((error) => {
      console.log(error.response);
      return false;
    });

  // var myHeaders = new Headers();
  // myHeaders.append("Content-Type", "application/json");
  // const encodenewuserID=Buffer.from((newDetailData[0].userID.email)).toString('base64');
  // const link=window.location.origin+'/email-activation/'+encodenewuserID;
  // var raw = JSON.stringify({
  //   "email": newDetailData[0].userID.email.toLowerCase(),
  //   "name" : newDetailData[0].first_name,
  //   "link": link
  // });

  // var requestOptions = {
  //   method: 'POST',
  //   headers: myHeaders,
  //   body: raw,
  //   redirect: 'follow'
  // };
  // console.log("UTIL raw===>",raw);
  // fetch(selfemailverification, requestOptions)
  //   .then(response => {
  //     response.text()
  //    // return true
  //     //dispatch({ type: RESEND_OTP,openTost:true,tostMsg:"Otp Sent Successfully" })
  //     //dispatch(loaderActions.stop());
  //   }
  //    )
  //   .then(async result => {
  //     let cnt=newDetailData[0].selfEmailTriggerCnt+1;
  //     const userDetailsData = { 'id':newDetailData[0].id,'selfEmailTriggerCnt':cnt,'selfEmailTriggerDt':new Date(Date.now()).toISOString(),'_version':newDetailData[0]._version};
  //     console.log("userDetailsData===>",userDetailsData);

  //     let userAdd=await API.graphql(graphqlOperation(updateUserProfileDetails, { input: userDetailsData }));
  //     return true;
  //   })
  //   .catch(error =>{
  //     console.log('error', error)
  //     return false

  //     //dispatch(loaderActions.stop());
  //   } );
}

export async function sendSelfverificationemailAdmin(userId) {
  //const userDetailsData = await API.graphql(graphqlOperation(queries.listUserProfileDetails,{filter: {userProfileDetailsUserMasterId: {eq: userId}},limit:10000}));
  const userDetailsData = await fetchItemsNextToken({
    query: queries.listUserProfileDetails,
    variables: {
      filter: { userProfileDetailsUserMasterId: { eq: userId } },
      limit: 500,
    },
  });

  const itemDetails = userDetailsData;
  let newDetailData = itemDetails.filter((item) => item._deleted !== true);

  const encodenewuserID = Buffer.from(newDetailData[0].userID.id).toString(
    "base64"
  );
  const link =
    window.location.origin + "/registration-completion/" + encodenewuserID;

  const apiName = "welcomeemaildev";
  const path = "/selfemailverification";
  const myInit = {
    body: {
      email: newDetailData[0].userID.email.toLowerCase(),
      name: newDetailData[0].first_name,
      link: link,
    },
  };

  await API.post(apiName, path, myInit)
    .then(async (response) => {
      let cnt = newDetailData[0].selfEmailTriggerCnt + 1;
      const userDetailsData = {
        id: newDetailData[0].id,
        selfEmailTriggerCnt: cnt,
        selfEmailTriggerDt: new Date(Date.now()).toISOString(),
      };

      let userAdd = await API.graphql(
        graphqlOperation(updateUserProfileDetails, { input: userDetailsData })
      );
      return true;
    })
    .catch((error) => {
      console.log(error.response);
      return false;
    });

  // var myHeaders = new Headers();
  // myHeaders.append("Content-Type", "application/json");
  // const encodenewuserID=Buffer.from((newDetailData[0].userID.id)).toString('base64');
  // const link=window.location.origin+'/registration-completion/'+encodenewuserID;
  // var raw = JSON.stringify({
  //   "email": newDetailData[0].userID.email.toLowerCase(),
  //   "name" : newDetailData[0].first_name,
  //   "link": link
  // });

  // var requestOptions = {
  //   method: 'POST',
  //   headers: myHeaders,
  //   body: raw,
  //   redirect: 'follow'
  // };
  // console.log("UTIL raw===>",raw);
  // fetch(selfemailverification, requestOptions)
  //   .then(response => {
  //     response.text()
  //    // return true
  //     //dispatch({ type: RESEND_OTP,openTost:true,tostMsg:"Otp Sent Successfully" })
  //     //dispatch(loaderActions.stop());
  //   }
  //    )
  //   .then(async result => {
  //     let cnt=newDetailData[0].selfEmailTriggerCnt+1;
  //     const userDetailsData = { 'id':newDetailData[0].id,'selfEmailTriggerCnt':cnt,'selfEmailTriggerDt':new Date(Date.now()).toISOString(),'_version':newDetailData[0]._version};
  //     console.log("userDetailsData===>",userDetailsData);

  //     let userAdd=await API.graphql(graphqlOperation(updateUserProfileDetails, { input: userDetailsData }));
  //     return true;
  //   })
  //   .catch(error =>{
  //     console.log('error', error)
  //     return false

  //     //dispatch(loaderActions.stop());
  //   } );
}

export async function sendReminderSms(userId) {
  //const userDetailsData = await API.graphql(graphqlOperation(queries.listUserProfileDetails,{filter: {userProfileDetailsUserMasterId: {eq: userId}},limit:10000}));
  const userDetailsData = await fetchItemsNextToken({
    query: queries.listUserProfileDetails,
    variables: {
      filter: { userProfileDetailsUserMasterId: { eq: userId } },
      limit: 500,
    },
  });

  const itemDetails = userDetailsData;
  let newDetailData = itemDetails.filter((item) => item._deleted !== true);

  const apiName = "welcomeemaildev";
  const path = "/mobileVerificationReminder";
  const myInit = {
    body: {
      mobile_no: newDetailData[0].mobile_no,
      country_code: newDetailData[0].mobileCountrycode,
    },
  };

  await API.post(apiName, path, myInit)
    .then(async (response) => {
      let cnt = newDetailData[0].mobileReminderSmsTriggerCnt + 1;
      const userDetailsData = {
        id: newDetailData[0].id,
        mobileReminderSmsTriggerCnt: cnt,
        mobileReminderSmsTriggerDt: new Date(Date.now()).toISOString(),
      };

      let userAdd = await API.graphql(
        graphqlOperation(updateUserProfileDetails, { input: userDetailsData })
      );

      return true;
    })
    .catch((error) => {
      console.log(error.response);
    });

  // var myHeaders = new Headers();
  // myHeaders.append("Content-Type", "application/json");

  // var raw = JSON.stringify({
  //   "mobile_no": newDetailData[0].mobile_no,
  //   "country_code" :newDetailData[0].mobileCountrycode,

  // });

  // var requestOptions = {
  //   method: 'POST',
  //   headers: myHeaders,
  //   body: raw,
  //   redirect: 'follow'
  // };
  // console.log("UTIL raw===>",raw);
  // fetch(mbileverificationreminder, requestOptions)
  //   .then(response => {
  //     response.text()
  //   }
  //    )
  //   .then(async(result) => {
  //     let cnt=newDetailData[0].mobileReminderSmsTriggerCnt+1;
  //     const userDetailsData = { 'id':newDetailData[0].id,'mobileReminderSmsTriggerCnt':cnt,'mobileReminderSmsTriggerDt':new Date(Date.now()).toISOString(),'_version':newDetailData[0]._version};
  //     console.log("userDetailsData===>",userDetailsData);

  //     let userAdd=await API.graphql(graphqlOperation(updateUserProfileDetails, { input: userDetailsData }));

  //     return true
  //   })
  //   .catch(error =>{
  //     console.log('error', error)
  //     return false

  //     //dispatch(loaderActions.stop());
  //   } );
}

export async function getCountryUserData(countryid, stateid, cityid) {
  var data1 = {
    countryname: "",
    statename: "",
    cityname: "",
  };
  let countryData = await API.graphql(
    graphqlOperation(queries.getCountries, { id: countryid })
  );
  let newCountry = countryData.data.getCountries;

  let stateData = await API.graphql(
    graphqlOperation(queries.getStates, { id: stateid })
  );
  let newState = stateData.data.getStates;

  let cityData = await API.graphql(
    graphqlOperation(queries.getCities, { id: cityid })
  );
  let newCity = cityData.data.getCities;

  data1 = {
    countryname: newCountry.name,
    statename: newState.name,
    cityname: newCity.name,
  };

  return data1;
  // await fetch(process.env.PUBLIC_URL+`/countries-states-cities.json`)
  //     .then(response => response.json())
  //     .then(data => {
  //       console.log(data);

  //       if(countryid>0)
  //       {
  //         console.log('countryid',countryid)
  //         console.log('stateid',stateid)
  //         console.log('cityid',cityid)

  //           const resCountry= data.find(country => country.id == countryid);
  //           const resState= resCountry.states.find(state => state.id == stateid);
  //           const resCity= resState.cities.find(city => city.id == cityid);

  //           data1= {
  //               "countryname":resCountry.name,
  //               "statename":resState.name,
  //               "cityname":resCity.name
  //           }
  //           console.log('data11',data1);

  //       }
  //       return data1
  //     })
  //     return data1
}

export async function insertUserInfo(data) {
  return true;
}

export async function updateUserInfo(data) {
  return true;
}

export async function getFriendsconnections(userID) {
  let friends = [];

  let userDeatilsData = await API.graphql(
    graphqlOperation(queries.getUserProfileDetails, { id: userID })
  );
  let deatilsUser = userDeatilsData.data.getUserProfileDetails;

  if (deatilsUser) {
    let connections = deatilsUser.connections.items;
    for (let i = 0; i < connections.length; i++) {
      const element = connections[i];

      let userConnectData = await API.graphql(
        graphqlOperation(queries.userConnectionsByConnectionId, {
          connectionId: element.connectionId,
          limit: 1000000000,
        })
      );
      if (userConnectData.data.userConnectionsByConnectionId.items.length > 0) {
        let users = userConnectData.data.userConnectionsByConnectionId.items;

        for (let i = 0; i < users.length; i++) {
          const element1 = users[i];
          if (element1.userProfileDetailsId != userID) {
            element1.userProfileDetails.connCreatedAt = element1.createdAt;
            friends.push(element1.userProfileDetails);
          }
        }
      }
    }
  }

  return friends;
  // let response=await fetchItemsNextToken({query:queries.listUsers,variables:{
  //   filter: {userID: {eq: userID}},limit:1000000
  // }})

  // let friends=[];
  // if(response.length>0)
  // {
  //   let connections=response[0].connections.items;
  //   let newUserID=response[0].id;

  //   for (let i = 0; i < connections.length; i++) {
  //     const element = connections[i];
  //     if(element?.connection?.users?.items.length>0)
  //     {
  //       let users=element.connection.users.items
  //       for (let j = 0; j < users.length; j++) {
  //         const element1 = users[j];
  //         console.log('element1',element1);
  //         if(element1.user.id!=newUserID)
  //         {
  //           //element1.user.userID=userID
  //           element1.user.connCreatedAt=element1.createdAt
  //           friends.push(element1.user)
  //         }
  //       }
  //     }
  //   }

  // }

  // return friends
}

export async function sendInvitation(userID, toEmailID) {
  /*CONNECT STATUS coneectStatus
    0==> Not Myshpehre user called lamda function
    1==>  Myshpehre user and both connected
    2==>  Myshpehre user and both Not connected send connection request
    3==>  Myshpehre user and one of then send request already
  */
  var currentStatus = {
    type: "",
    msg: "",
  };
  const userStatus = await checkConnection(userID, toEmailID);

  if (userStatus.connectionstatus == 0) {
    //Not Myshpehre user called lamda function
    const apiName = "welcomeemaildev";
    const path = "/userinvitation";
    const myInit = {
      body: {
        senderUserId: userID,
        senderUserEmail: userStatus.FromEmail,
        senderUserName: userStatus.FromName,
        toEmail: toEmailID.toLowerCase(),
        toName: "",
        status: 0,
        createdAt: new Date(Date.now()).toISOString(),
        updatedAt: new Date(Date.now()).toISOString(),
      },
    };

    await API.post(apiName, path, myInit)
      .then((result) => {
        currentStatus = {
          type: "success",
          msg: "Your invite has been sent",
        };
      })
      .catch((error) => {
        console.log(error.response);
      });

    // var myHeaders = new Headers();
    // myHeaders.append("Content-Type", "application/json");

    // var  raw = JSON.stringify({

    //   "senderUserId":userID,
    //   "senderUserEmail": userStatus.FromEmail,
    //   "senderUserName": userStatus.FromName,
    //   "toEmail": toEmailID.toLowerCase(),
    //   "toName": "",
    //   "status": 0,
    //   "createdAt":new Date(Date.now()).toISOString(),
    //   "updatedAt":new Date(Date.now()).toISOString(),

    // });
    // //console.log("raw==>",raw);
    // console.log("requestOptions==>",raw);
    // //return false;
    // var requestOptions = {
    //   method: 'POST',
    //   headers: myHeaders,
    //   body: raw,
    //   redirect: 'follow'
    // };

    // //fetch(otpvarify, requestOptions)
    // await fetch(userinvitation, requestOptions)
    //   .then(response => response.json())
    //   .then(async result =>{

    //     if(result.statusCode==200)
    //     {
    //       console.log("RES===>",result.statusCode);
    //       currentStatus={
    //         'type':"success",
    //         'msg':"Your invite has been sent",

    //       };

    //     }

    //     })
    //     .catch(error => {console.log('error', error);});
  } else if (userStatus.connectionstatus == 1) {
    // both user  connected return error
    currentStatus = {
      type: "error",
      msg: "You already conected with this user.",
    };
  } else if (userStatus.connectionstatus == 2) {
    //user not connected then send connection request
    let userDetailsData = {
      from_user_id: userStatus.FromUserID,
      to_user_id: userStatus.toUserID,
      status: 0,
    };
    let res = await API.graphql(
      graphqlOperation(createFriendRequest, { input: userDetailsData })
    );
    if (res.data.createFriendRequest) {
      currentStatus = {
        type: "success",
        msg: "Connection request sent",
      };
    } else {
      currentStatus = {
        type: "error",
        msg: "Something went wrong! Please try again",
      };
    }
  } else if (userStatus.connectionstatus == 3) {
    //one of user requst already sent and pending for approval
    currentStatus = {
      type: "error",
      msg: "You have already sent a connection request to this user",
    };
  } else if (userStatus.connectionstatus == 4) {
    //one of user requst already sent and pending for approval
    currentStatus = {
      type: "error",
      msg: "You have already sent a invite to this user",
    };
  }

  return currentStatus;
}

const checkConnection = async (FromUserID, toEmailID) => {
  /*CONNECT STATUS coneectStatus
    0==> Not Myshpehre user called lamda function
    1==>  Myshpehre user and both connected
    2==>  Myshpehre user and both Not connected send connection request
    3==>  Myshpehre user and one of then send request already
  */
  var coneectStatus = {
    connectionstatus: 0,
    toUserID: 0,
    FromUserID: FromUserID,
    FromName:
      localStorage.getItem("firstName") +
      " " +
      localStorage.getItem("lastName"),
    FromEmail: localStorage.getItem("email"),
    toName: "",
    toEmail: toEmailID,
  };

  let logUser = FromUserID;
  //let useAccessRole=JSON.parse(localStorage.getItem('useAccessRole'));

  const userData = await fetchItemsNextToken({
    query: queries.listUserMasters,
    variables: { filter: { email: { eq: toEmailID } }, limit: 10000000 },
  });
  const items = userData;
  let newData = items.filter((item) => item._deleted !== true);

  if (newData.length > 0) {
    //mysphere user
    const userDetailsData = await fetchItemsNextToken({
      query: queries.listUserProfileDetails,
      variables: {
        filter: { userProfileDetailsUserMasterId: { eq: newData[0].id } },
        limit: 500,
      },
    });

    const itemDetails = userDetailsData;
    let newDetailData = itemDetails.filter((item) => item._deleted !== true);
    let toUser = newDetailData[0].id;

    let filter = {
      or: [
        {
          and: [
            { from_user_id: { eq: toUser } },
            { to_user_id: { eq: logUser } },
          ],
        },
        {
          and: [
            { from_user_id: { eq: logUser } },
            { to_user_id: { eq: toUser } },
          ],
        },
      ],
    };
    const fromuserDetailsData = await fetchItemsNextToken({
      query: queries.listFriendRequests,
      variables: { filter: filter, limit: 1000000 },
    });
    const connectionData = fromuserDetailsData;
    if (connectionData.length > 0) {
      if (connectionData[0].status == 1) {
        coneectStatus = {
          connectionstatus: 1,
          toUserID: toUser,
          FromUserID: FromUserID,
          FromName:
            localStorage.getItem("firstName") +
            " " +
            localStorage.getItem("lastName"),
          FromEmail: localStorage.getItem("email"),
          toName: newDetailData[0].firstName + " " + newDetailData[0].lastName,
          toEmail: newDetailData[0].email,
        };
      } else {
        //setShowRequested(true);
        coneectStatus = {
          connectionstatus: 3,
          toUserID: toUser,
          FromUserID: FromUserID,
          FromName:
            localStorage.getItem("firstName") +
            " " +
            localStorage.getItem("lastName"),
          FromEmail: localStorage.getItem("email"),
          toName: newDetailData[0].firstName + " " + newDetailData[0].lastName,
          toEmail: newDetailData[0].email,
        };
      }
    } else {
      coneectStatus = {
        connectionstatus: 2,
        toUserID: toUser,
        FromUserID: FromUserID,
        FromName:
          localStorage.getItem("firstName") +
          " " +
          localStorage.getItem("lastName"),
        FromEmail: localStorage.getItem("email"),
        toName: newDetailData[0].firstName + " " + newDetailData[0].lastName,
        toEmail: newDetailData[0].email,
      };

      //not connected
      //setShowConnect(true);
    }
  } // not maysphere user call Lamda function
  else {
    const filter = {
      toEmail: {
        eq: toEmailID,
      },
      senderUserId: {
        eq: FromUserID,
      },
    };
    const fromuserDetailsData = await fetchItemsNextToken({
      query: queries.listInviteConnections,
      variables: { filter: filter, limit: 1000000 },
    });
    const inviteconnectionData = fromuserDetailsData;
    if (inviteconnectionData.length > 0) {
      coneectStatus = {
        connectionstatus: 4,
        toUserID: 0,
        FromUserID: FromUserID,
        FromName:
          localStorage.getItem("firstName") +
          " " +
          localStorage.getItem("lastName"),
        FromEmail: localStorage.getItem("email"),
        toName: "",
        toEmail: toEmailID,
      };
    } else {
      coneectStatus = {
        connectionstatus: 0,
        toUserID: 0,
        FromUserID: FromUserID,
        FromName:
          localStorage.getItem("firstName") +
          " " +
          localStorage.getItem("lastName"),
        FromEmail: localStorage.getItem("email"),
        toName: "",
        toEmail: toEmailID,
      };
    }
  }
  return coneectStatus;
};

export const sendRequestAfterRegd = async (toEmailID, toUserId) => {
  var currentStatus = {
    type: "",
    msg: "",
  };

  const filter = {
    toEmail: {
      eq: toEmailID,
    },
  };
  const fromuserDetailsData = await fetchItemsNextToken({
    query: queries.listInviteConnections,
    variables: { filter: filter, limit: 1000000 },
  });
  const inviteconnectionData = fromuserDetailsData;
  if (inviteconnectionData.length > 0) {
    for (let i = 0; i < inviteconnectionData.length; i++) {
      let userDetailsData = {
        from_user_id: inviteconnectionData[i].senderUserId,
        to_user_id: toUserId,
        status: 0,
      };
      let res = await API.graphql(
        graphqlOperation(createFriendRequest, { input: userDetailsData })
      );
      if (res.data.createFriendRequest) {
        let userDetailsData1 = {
          id: inviteconnectionData[i].id,
          status: 1,
        };
        let res1 = await API.graphql(
          graphqlOperation(updateInviteConnections, { input: userDetailsData1 })
        );
        if (res1.data.updateInviteConnections) {
          currentStatus = {
            type: "success",
            msg: "connection request sent.",
          };
        } else {
          currentStatus = {
            type: "error",
            msg: "Something went wrong! Please try again.",
          };
        }
      } else {
        currentStatus = {
          type: "error",
          msg: "Something went wrong! Please try again.",
        };
      }
    }
  }
};

export async function getProfileLink(userID, link) {
  if (userID != "") {
    //mysphere user
    const userDetailsData = await fetchItemsNextToken({
      query: queries.listUserProfileDetails,
      variables: { filter: { id: { eq: userID } }, limit: 500 },
    });

    const itemDetails = userDetailsData;
    let newDetailData = itemDetails.filter((item) => item._deleted !== true);

    return appLink + "profile/" + newDetailData[0].username;
  }
}

export async function updateUserProject(from_user_id, to_user_id) {
  let cardDataQuery = await fetchItemsNextToken({
    query: queries.listCards,
    variables: {
      filter: {
        userprofiledetailsID: { eq: from_user_id },
        title: { eq: "portfolio" },
      },
      limit: 10000000,
    },
  });
  let getCardData = cardDataQuery.filter((item) => item._deleted !== true);
  if (getCardData.length > 0) {
    let cardItemDataQuery = await fetchItemsNextToken({
      query: queries.listCardItems,
      variables: {
        filter: { cardID: { eq: getCardData[0].id } },
        limit: 10000000,
      },
    });
    let getCardItemData = cardItemDataQuery
      .filter((item) => item._deleted !== true)
      .sort((a, b) => b.createdAt.localeCompare(a.createdAt));
    if (getCardItemData.length > 0) {
      let userData = await API.graphql(
        graphqlOperation(queries.getUserProfileDetails, { id: to_user_id })
      );
      let newData = userData.data.getUserProfileDetails;

      if (newData.userID.email) {
        for (let i = 0; i < getCardItemData.length; i++) {
          const element = getCardItemData[i];

          let data = JSON.parse(element.newdata);
          let flag = 0;
          if (data.teamMemberByArrData) {
            let teamMemberByArrData = JSON.parse(data.teamMemberByArrData);
            let obj = teamMemberByArrData.findIndex(
              (item) => item.useremail == newData.userID.email
            );
            if (obj > 0) {
              teamMemberByArrData[obj] = {
                first_name: newData.first_name,
                last_name: newData.last_name,
                id: newData.id,
                userID: newData.id,
                connCreatedAt: new Date(Date.now()).toISOString(),
              };
              flag = 1;
              let userDetailsData = {
                cartItem_id: getCardItemData[i].id,
                data: element.newdata,
                status: 1,
                type: "team_members",
                userProfileDetailsUserActivityId:
                  localStorage.getItem("userDetailsID"),
              };
              let res = await API.graphql(
                graphqlOperation(createUserActivity, { input: userDetailsData })
              );
            }

            let guidanceByArrData = JSON.parse(data.guidanceByArrData);
            let obj1 = guidanceByArrData.findIndex(
              (item) => item.useremail == newData.userID.email
            );
            if (obj1 > 0) {
              guidanceByArrData[obj1] = {
                first_name: newData.first_name,
                last_name: newData.last_name,
                id: newData.id,
                userID: newData.id,
                connCreatedAt: new Date(Date.now()).toISOString(),
              };
              flag = 1;
              let userDetailsData = {
                cartItem_id: getCardItemData[i].id,
                data: element.data,
                status: 1,
                type: "team_members",
                userProfileDetailsUserActivityId:
                  localStorage.getItem("userDetailsID"),
              };
              let res = await API.graphql(
                graphqlOperation(createUserActivity, { input: userDetailsData })
              );
            }
            if (flag === 1) {
              data.guidanceByArrData = JSON.stringify(guidanceByArrData);
              data.teamMemberByArrData = JSON.stringify(teamMemberByArrData);

              const userUpdateData = {
                id: element.id,
                data: JSON.stringify(data),
              };
              let dataUpdated = await API.graphql(
                graphqlOperation(updateCardItems, { input: userUpdateData })
              );
            }
          }
        }
      }
    }
  }
}

export async function insertUserProjectActivity(
  userID,
  teamMembers,
  guidanceBy,
  cardItemData
) {

  let carddata = JSON.parse(cardItemData.newdata);
  let projectddata = JSON.parse(cardItemData.newdata);

  let icon = carddata.memberProfile ? carddata.memberProfile : "";
  var notificationdata = {
    icon: "",
    subcategory: "",
    fromUsername: "",
    toUserId: "",
    toUsername: "",
    link: "",
  };
  const cvallowed = Buffer.from("cvallowed").toString("base64");

  let members = [];
  if (teamMembers.length > 0) {
    for (let i = 0; i < teamMembers.length; i++) {
      const element = teamMembers[i];
      if (element.id) {
        teamMembers[i].type = "team_members";
        let toUserID = element.id;
        teamMembers[i].userUserActivityId = toUserID;
        // console.log("check team members", element)
        await API.graphql(
          graphqlOperation(updateUserProfileDetails, {
            input: {
              id: element.id,
              mystuffCount:
                element.mystuffCount >= 0 ? element.mystuffCount + 1 : 1,
            },
          })
        );
        members = [...members, teamMembers[i]];
        notificationdata = {
          icon: localStorage.getItem("profile_image"),
          subcategory: "add_project_teammember",
          fromUsername:
            localStorage.getItem("firstName") +
            " " +
            localStorage.getItem("lastName"),
          toUserId: toUserID,
          toUsername: element.first_name + " " + element.last_name,
          link:
            "/project/" +
            localStorage.getItem("username") +
            "/" +
            cardItemData.id +
            "?cv=" +
            cvallowed,
          projectName: projectddata.title,
          uploaded_image: localStorage.getItem("uploaded_image"),
        };

        sendNotitication(notificationdata);
      }
    }
  }
  if (guidanceBy.length > 0) {
    for (let i = 0; i < guidanceBy.length; i++) {
      const element = guidanceBy[i];
      if (element.id) {
        guidanceBy[i].type = "guidance_by";
        let toUserID = element.id;
        guidanceBy[i].userUserActivityId = toUserID;
        await API.graphql(
          graphqlOperation(updateUserProfileDetails, {
            input: {
              id: element.id,
              mystuffCount:
                element.mystuffCount >= 0 ? element.mystuffCount + 1 : 1,
            },
          })
        );
        members = [...members, guidanceBy[i]];
        notificationdata = {
          icon: localStorage.getItem("profile_image"),
          subcategory: "add_project_guide",
          fromUsername:
            localStorage.getItem("firstName") +
            " " +
            localStorage.getItem("lastName"),
          toUserId: toUserID,
          toUsername: element.first_name + " " + element.last_name,
          link:
            "/project/" +
            localStorage.getItem("username") +
            "/" +
            cardItemData.id +
            "?cv=" +
            cvallowed,
          projectName: projectddata.title,
          uploaded_image: localStorage.getItem("uploaded_image"),
        };

        sendNotitication(notificationdata);
      }
    }
  }
  let cartItemID = cardItemData.id;
  let data = JSON.stringify(cardItemData);
  if (members.length > 0) {
    //let fromUserId=await getUserInfo(userID);
    for (let k = 0; k < members.length; k++) {
      const element = members[k];
      let userDetailsData = {
        cartItem_id: cartItemID,
        data: data,
        status: 1,
        type: element.type,
        userProfileDetailsUserActivityId: element.userUserActivityId,
      };
      let res = await API.graphql(
        graphqlOperation(createUserActivity, { input: userDetailsData })
      );
    }
  }

  return true;
}

export async function getUserInfo(userID) {}

export async function deleteUserProjectActivity(userID, cardItemData) {
  let cartItemID = cardItemData.id;
  let cardDataQuery = await fetchItemsNextToken({
    query: queries.listUserActivities,
    variables: { filter: { cartItem_id: { eq: cartItemID } }, limit: 10000 },
  });
  let getCardData = cardDataQuery.filter((item) => item._deleted !== true);
  if (getCardData.length > 0) {
    let items = getCardData;
    // console.log("check items ", items)
    for (let i = 0; i < items.length; i++) {
      const element = items[i];
      if (element?.to_user_id?.id) {
        await API.graphql(
          graphqlOperation(updateUserProfileDetails, {
            input: {
              id: element.to_user_id.id,
              mystuffCount:
                element.to_user_id.mystuffCount >= 0
                  ? element.to_user_id.mystuffCount - 1
                  : 0,
            },
          })
        );
      }
      await deleteAcitivity(element.id);
    }
  } else {
    return false;
  }
}

async function deleteAcitivity(id) {
  let res = await API.graphql(
    graphqlOperation(deleteUserActivity, { input: { id: id } })
  );
  if (res.data.deleteUserActivity) {
    return res.data.deleteUserActivity.id;
  } else {
    return false;
  }
}

export async function sendNotitication(data) {

  const apiName = "welcomeemaildev";
  const path = "/notification";
  const myInit = {
    body: {
      icon: data.icon,
      subcategory: data.subcategory,
      fromUsername: data.fromUsername,
      toUserId: data.toUserId,
      toUsername: data.toUsername,
      link: data.link,
      projectName: data.projectName,
      uploaded_image: data.uploaded_image,
    },
  };

  await API.post(apiName, path, myInit)
    .then((response) => {
      // Add your code here
    })
    .catch((error) => {
      console.log(error.response);
    });
  // var myHeaders = new Headers();
  // myHeaders.append("Content-Type", "application/json");

  // var  raw = JSON.stringify({

  //   "icon":data.icon,
  //   "subcategory":data.subcategory,
  //   "fromUsername": data.fromUsername,
  //   "toUserId": data.toUserId,
  //   "toUsername": data.toUsername,
  //   "link": data.link,
  //   "projectName": data.projectName,
  //   "uploaded_image":data.uploaded_image

  // });
  // console.log("requestOptions==>",raw);
  // var requestOptions = {
  //   method: 'POST',
  //   headers: myHeaders,
  //   body: raw,
  //   redirect: 'follow'
  // };

  // await fetch(notification, requestOptions)
  //   .then(response => response.json())
  //   .then(async result =>{

  //     if(result.statusCode==200)
  //     {
  //       console.log("RES===>",result.statusCode);
  //     }
  //     })
  //     .catch(error => {console.log('error', error);});
}

export async function getAccomplishmentsCount(userID, type) {
  let total_count = 0;
  let filter = {};
  let cardDataQuery = await fetchItemsNextToken({
    query: queries.listCards,
    variables: {
      filter: { userprofiledetailsID: { eq: userID }, title: { eq: type } },
      limit: 10000,
    },
  });
  let getCardData = cardDataQuery.filter((item) => item._deleted !== true);
  if (getCardData.length > 0) {
    filter = { cardID: { eq: getCardData[0].id }, status: { eq: 1 } };
    let cardItemDataQuery = await fetchItemsNextToken({
      query: queries.listCardItems,
      variables: { filter: filter, limit: 10000 },
    });
    if (cardItemDataQuery) {
      total_count = cardItemDataQuery
        .filter((item) => item._deleted !== true)
        .filter((item) => item._deleted !== true).length;
    }
    //setTotalCount(totalCount);
  }
  return total_count;
}

export async function getConnectionCount(userID, type) {
  let total_count = 0;

  //let field=(type=="receive")?"to_user_id":"from_user_id";
  let filter = {};
  if (type === 0) {
    filter = { to_user_id: { eq: userID }, status: { eq: type } };
  } else {
    filter = {
      or: [
        {
          from_user_id: { eq: userID },
        },
        {
          to_user_id: { eq: userID },
        },
      ],
      status: { eq: type },
    };
  }
  const fromuserDetailsData = await fetchItemsNextToken({
    query: queries.listFriendRequests,
    variables: { filter: filter, limit: 1000000 },
  });
  const res = fromuserDetailsData;
  if (res) {
    total_count = res.length;
  }
  return total_count;

  //       const  res=await axiosItemsNextToken({query:queriesDB.listFriendRequests,variables:{
  //         filter: filter,limit:1000000
  //       }});
  //       if(res)
  //       {
  //         total_count=res.length;
  //       }
  // return total_count;
}

export async function smartTechEventLog(email, event) {
  if (env == "prod") {
    window.smartech("debug", 1);
    window.smartech(
      "contact",
      100,
      {
        "pk^email": email,
      },
      function () {
        window.smartech("identify", email);
        window.smartech("dispatch", event, {
          loginAt: `${new Date(Date.now()).toISOString()}`,
        });
      }
    );
  }
}

export async function connectionRequestSendEamil(data) {
  const apiName = "welcomeemaildev";
  const path = "/connectionrequestsent";
  const myInit = {
    body: {
      email: data.email,
      name: data.toUsername,
      fromname: data.fromUsername,
      link: data.link,
      cdate: data.cdate,
      schoolname: data.schoolname,
    },
  };

  await API.post(apiName, path, myInit)
    .then((result) => {
      if (result.statusCode == 200) {
        console.log("RES===>", result.statusCode);
      }
    })
    .catch((error) => {
      console.log(error.response);
    });
  // console.log("DATA==>",data.fromUsername);
  // var myHeaders = new Headers();
  // myHeaders.append("Content-Type", "application/json");

  // var  raw = JSON.stringify({

  //   email: data.email,
  //   name: data.toUsername,
  //   fromname: data.fromUsername,
  //   link: data.link,
  //   cdate:data.cdate,
  //   schoolname: data.schoolname

  // });
  // //console.log("raw==>",raw);
  // console.log("requestOptions==>",raw);
  // //return false;
  // var requestOptions = {
  //   method: 'POST',
  //   headers: myHeaders,
  //   body: raw,
  //   redirect: 'follow'
  // };

  // //fetch(otpvarify, requestOptions)
  // await fetch(connectionrequestsent, requestOptions)
  //   .then(response => response.json())
  //   .then(async result =>{

  //     if(result.statusCode==200)
  //     {
  //       console.log("RES===>",result.statusCode);

  //     }

  //     })
  //     .catch(error => {console.log('error', error);});
}

export async function connectionAcceptSendEamil(data) {

  const apiName = "welcomeemaildev";
  const path = "/connectionrequestaccept";
  const myInit = {
    body: {
      email: data.email,
      name: data.toUsername,
      fromname: data.fromUsername,
      link: data.link,
    },
  };

  await API.post(apiName, path, myInit)
    .then((result) => {
      if (result.statusCode == 200) {
        console.log("RES===>", result.statusCode);
      }
    })
    .catch((error) => {
      console.log(error.response);
    });
  // var myHeaders = new Headers();
  // myHeaders.append("Content-Type", "application/json");

  // var  raw = JSON.stringify({

  //   email: data.email,
  //   name: data.toUsername,
  //   fromname: data.fromUsername,
  //   link: data.link,

  // });
  // //console.log("raw==>",raw);
  // console.log("requestOptions==>",raw);
  // //return false;
  // var requestOptions = {
  //   method: 'POST',
  //   headers: myHeaders,
  //   body: raw,
  //   redirect: 'follow'
  // };

  // //fetch(otpvarify, requestOptions)
  // await fetch(connectionrequestaccept, requestOptions)
  //   .then(response => response.json())
  //   .then(async result =>{

  //     if(result.statusCode==200)
  //     {
  //       console.log("RES===>",result.statusCode);

  //     }

  //     })
  //     .catch(error => {console.log('error', error);});
}

export async function addPostView(userID, postID) {
  let userIP = localStorage.getItem("userIP");
  let userNewID = 0;
  if (userID) {
    userNewID = userID;
  }

  let response = await fetchItemsNextToken({
    query: queries.listPostViews,
    variables: {
      filter: { postsViewsId: { eq: postID }, ipAddress: { eq: userIP } },
      limit: 1000000,
    },
  });
  if (response.length > 0) {
    let res = response.sort((a, b) => b.createdAt.localeCompare(a.createdAt));
    var dD = moment(res[0].createdAt).isSameOrAfter(
      moment().add(1, "days"),
      "day"
    );

    if (dD) {
      let userDetailsData = {
        userProfileDetailsViewsId: userNewID,
        postsViewsId: postID,
        status: true,
        ipAddress: userIP,
      };
      let res = await API.graphql(
        graphqlOperation(createPostViews, { input: userDetailsData })
      );
    }
  } else {
    let userDetailsData = {
      userProfileDetailsViewsId: userNewID,
      postsViewsId: postID,
      status: true,
      ipAddress: userIP,
    };
    let res = await API.graphql(
      graphqlOperation(createPostViews, { input: userDetailsData })
    );
  }

  return true;
}

export async function getWordpressPosts() {}

export async function getOldUserInfo(userID) {}

export async function getQuizScore(userID) {
  let avgScore = 0;
  let filter = { userProfileDetailsQuizResultsId: { eq: userID } };
  let res = await fetchItemsNextToken({
    query: queries.listQuizResults,
    variables: {
      filter: filter,
      limit: 1000000,
    },
  });

  if (res.length > 0) {
    let avgS = 0;

    let allquizesAsc = res
      .filter((item) => item._deleted !== true)
      .sort((a, b) => a.createdAt.localeCompare(b.createdAt));

    let uniqueQuizes = unique(allquizesAsc, [
      "userProfileDetailsQuizResultsId",
      "postsQuizResultsId",
    ]);
    for (let i = 0; i < uniqueQuizes.length; i++) {
      const element = uniqueQuizes[i];

      avgS += (element.quizScore / element.totalScore) * 100;
    }
    if (avgS > 0) {
      let score = avgS / uniqueQuizes.length;
      avgScore = Math.round(score);
    }
  }
  return avgScore;
}

function unique(arr, keyProps) {
  const kvArray = arr.map((entry) => {
    const key = keyProps.map((k) => entry[k]).join("|");
    return [key, entry];
  });
  const map = new Map(kvArray);
  return Array.from(map.values());
}

export function convertStrToJson(input) {
  // Remove the curly braces at the beginning and end of the string
  const trimmedInput = input.slice(1, -1);

  // Split the string into an array of key-value pairs
  const keyValuePairs = trimmedInput.split(", ");

  // Convert the array of key-value pairs into an object
  const obj = {};
  keyValuePairs.forEach((pair) => {
    const [key, value] = pair.split("=");
    obj[key] = value;
  });
  return JSON.stringify(obj);
}

export async function deleteAllInterest(userID) {
  let userData = await fetchSearchItemsNextToken({
    query: queries.searchInterestUsers,
    variables: {
      filter: { userProfileDetailsInterestsId: { eq: userID } },
      limit: 500,
    },
  });
  const items = userData;
  let newData = items.filter((item) => item._deleted !== true);
  if (newData.length > 0) {
    for (let i = 0; i < newData.length; i++) {
      const element = newData[i];
      let res = await API.graphql(
        graphqlOperation(deleteInterestUser, { input: { id: element.id } })
      );
    }
  }

  let userData1 = await fetchSearchItemsNextToken({
    query: queries.searchSubinterestUsers,
    variables: {
      filter: { userProfileDetailsSubinterestsId: { eq: userID } },
      limit: 500,
    },
  });
  const items1 = userData1;
  let newData1 = items1.filter((item) => item._deleted !== true);
  if (newData1.length > 0) {
    for (let i = 0; i < newData1.length; i++) {
      const element1 = newData1[i];
      let res = await API.graphql(
        graphqlOperation(deleteSubinterestUser, { input: { id: element1.id } })
      );
    }
  }
}

export function getUserAuthStatus(
  isDisabled,
  isMinor,
  isParentVerified,
  isMobileVerified,
  isEmailVerified
) {
  // We used rules from userAccessRole table to determine the user status from these fields [isDisabled, isMinor, isParentVerified, isMobileVerified, isEmailVerified]

  if (isDisabled) {
    return "Disabled";
  }
  if (
    !isDisabled &&
    isMinor &&
    !isParentVerified &&
    !isMobileVerified &&
    !isEmailVerified
  ) {
    return "UEMM";
  }
  if (
    !isDisabled &&
    isMinor &&
    !isParentVerified &&
    !isMobileVerified &&
    isEmailVerified
  ) {
    return "PMM";
  }
  if (
    !isDisabled &&
    isMinor &&
    !isParentVerified &&
    isMobileVerified &&
    isEmailVerified
  ) {
    return "PCM";
  }
  if (
    !isDisabled &&
    isMinor &&
    isParentVerified &&
    isMobileVerified &&
    isEmailVerified
  ) {
    return "FA";
  }
  if (!isDisabled && !isMinor && isMobileVerified && isEmailVerified) {
    return "FA";
  }
  if (!isDisabled && !isMinor && !isMobileVerified && isEmailVerified) {
    return "UM";
  }
  if (!isDisabled && !isMinor && !isMobileVerified && !isEmailVerified) {
    return "UEM";
  }
  return null
}

export async function  customAPIRequest(fnName, data) {
  try {
    let params = new URLSearchParams();
    let moodleURL = moodleApiUrl
    let newURL = "";
    params.set("wstoken", moodleToken);
    params.set("wsfunction", fnName);
    params.set("moodlewsrestformat", "json");

    for (var key in data) {
      params.set(key, data[key]);
    }
    newURL = `${moodleURL}?${params.toString()}`;

    let response = await axios.request(newURL);
    for (var key in data) {
      params.delete(key);
    }
    return response;
  } catch (error) {
    console.log("error ", error);
    console.error("Error in calling moodle api", error)
    return null;
  }
}  

export async function getSignedUrl(key, { level }) {
  try {
    let lvl = level !== null || level !== undefined ? level : "public";
    const { signedUrl } = await API.post('welcomeemaildev', '/getsignedurl', {
      body: {
        objectKey: `${lvl}/${key}`,
        cloudfrontUrl: s3CloudFrontUrl,
        cloudfrontKeyPairID: cloudfrontKeyPairId
      }
    })

    console.log("signedUrl in getSignedUrl utility", signedUrl)

    return signedUrl !== null || signedUrl !== undefined ? signedUrl : null;
  } catch(error) {
    console.log("Error in getting signed url", error);
    console.error("Error in getting signed url", error)
    return null;
  }
}

// export async function getIpAddress(cogntioUser = null) {
//   try {
//     const currentCogntioUser = cogntioUser ? cogntioUser : await Auth.currentAuthenticatedUser();
//     console.log("cogntioUser", currentCogntioUser)
//     const accessToken = currentCogntioUser.signInUserSession.accessToken.jwtToken
//     const deviceKey = currentCogntioUser.signInUserSession.accessToken.payload.device_key

//     const userDevicesResponse = await API.post("welcomeemaildev","/userdevices", {
//       body: {
//         accessToken: accessToken,
//         isPasswordChange: false
//       }
//     })

//     console.log("User Devices Response", userDevicesResponse) 

//     if(userDevicesResponse.devices.length > 0) {
//       const device = userDevicesResponse.devices.find(device => device.DeviceKey === deviceKey)
//       if(device) {
//         console.log("Device", device)
//         const ip = device.DeviceAttributes.find(attr => attr.Name === "last_ip_used")  
//         console.log("IP Address", ip)
//         return ip || null;
//       }
//     }
//     return null;
//   } catch (error) {
//     console.error("Error in getting IP Address", error)
//     return null;
//   }
// }